import { render, staticRenderFns } from "./TaskModal.vue?vue&type=template&id=5b62a658&scoped=true&"
import script from "./TaskModal.vue?vue&type=script&lang=js&"
export * from "./TaskModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b62a658",
  null
  
)

export default component.exports